/**
 * Juwelier Reichart · festgehaltene Galerie (sections/jr-galerie.liquid).
 * Die Bühne wird so hoch wie der seitliche Weg der Spur; beim Scrollen bleibt die Galerie stehen und die Spur wandert
 * nach links. Nur ab 990 px Breite und ohne Wunsch nach reduzierter Bewegung – sonst bleibt die wischbare Reihe.
 */

class JrGalerie extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bereit) return;
    this.dataset.bereit = '1';
    this.halt = /** @type {HTMLElement} */ (this.querySelector('.jr-galerie__halt'));
    this.spur = /** @type {HTMLElement} */ (this.querySelector('.jr-galerie__spur'));
    if (!this.halt || !this.spur) return;
    this.breit = matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');

    this.planen = () => {
      if (this.bild) return;
      this.bild = requestAnimationFrame(() => {
        this.bild = 0;
        this.messen();
      });
    };
    this.vermessen = () => {
      this.einrichten();
      this.planen();
    };
    document.addEventListener('scroll', this.planen, { passive: true, capture: true });
    addEventListener('resize', this.vermessen, { passive: true });
    this.breit.addEventListener('change', this.vermessen);
    this.groesse = new ResizeObserver(this.vermessen);
    this.groesse.observe(this.spur);
    this.einrichten();
    this.messen();
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.planen, { capture: true });
    removeEventListener('resize', this.vermessen);
    this.breit?.removeEventListener('change', this.vermessen);
    this.groesse?.disconnect();
    if (this.bild) cancelAnimationFrame(this.bild);
  }

  einrichten() {
    const kopf = document.querySelector('header-component');
    const kopfHoehe = kopf ? Math.max(0, kopf.getBoundingClientRect().height) : 0;
    this.style.setProperty('--jr-kopf', `${Math.round(kopfHoehe)}px`);
    const an = this.breit.matches;
    this.classList.toggle('is-gehalten', an);
    if (!an) {
      this.style.height = '';
      this.spur.style.removeProperty('--jr-versatz');
      return;
    }
    // seitlicher Weg = Spurbreite minus sichtbare Breite
    this.weg = Math.max(0, this.spur.scrollWidth - this.halt.clientWidth);
    this.style.height = `${this.halt.offsetHeight + this.weg}px`;
  }

  messen() {
    const linie = this.querySelector('.jr-galerie__linie span');
    if (!this.classList.contains('is-gehalten')) {
      // wischbare Reihe: Fortschritt aus der waagerechten Scrollposition
      const max = this.spur.scrollWidth - this.spur.clientWidth;
      linie?.parentElement?.style.setProperty('--jr-fortschritt', max > 0 ? (this.spur.scrollLeft / max).toFixed(3) : '0');
      return;
    }
    const r = this.getBoundingClientRect();
    const kopf = parseFloat(getComputedStyle(this).getPropertyValue('--jr-kopf')) || 0;
    const fortschritt = this.weg > 0 ? Math.max(0, Math.min(1, (kopf - r.top) / this.weg)) : 0;
    this.spur.style.setProperty('--jr-versatz', `${(-fortschritt * this.weg).toFixed(1)}px`);
    linie?.parentElement?.style.setProperty('--jr-fortschritt', fortschritt.toFixed(3));
  }
}

if (!customElements.get('jr-galerie')) customElements.define('jr-galerie', JrGalerie);
